import { render, staticRenderFns } from "./pagetitle.vue?vue&type=template&id=7bc7d68e"
import script from "./pagetitle.vue?vue&type=script&lang=js"
export * from "./pagetitle.vue?vue&type=script&lang=js"
import style0 from "./pagetitle.vue?vue&type=style&index=0&id=7bc7d68e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports